import { render, staticRenderFns } from "./BdPopup.vue?vue&type=template&id=2e94ff32&"
import script from "./BdPopup.vue?vue&type=script&lang=js&"
export * from "./BdPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports